import styled from '@emotion/styled';

export const TableWrap = styled.div`
  overflow-x: auto;
`;
